import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';
import { TFunction } from 'i18next';

const useValidationSchema = (t: TFunction) => {
  const { required, hexaColor } = useValidators();

  const ExchangeNetworkFormSchema = yup.object().shape(
    {
      color: hexaColor(required(yup.string())),
      username: yup
        .string()
        .ensure()
        .when(['password'], {
          is: (password: any) => password,
          then: () => required(yup.string()),
        }),
      password: yup
        .string()
        .ensure()
        .when(['username'], {
          is: (username: any) => username,
          then: () => required(yup.string()),
        }),
    },
    [['username', 'password']],
  );

  const formItems = [
    {
      name: 'description',
      label: t('description'),
    },
    {
      name: 'ip',
      label: t('ip'),
    },
    {
      name: 'port',
      label: t('port'),
    },
    {
      name: 'urlForUpdate',
      label: t('urlForUpdate'),
    },
    {
      name: 'color',
      label: t('color'),
      required: true,
    },
    {
      name: 'username',
      label: t('username'),
    },
    {
      name: 'password',
      label: t('password'),
    },
  ];

  return { ExchangeNetworkFormSchema, formItems };
};

export default useValidationSchema;
